/**
 * Sortiert eine Liste von ToDo-Objekten nach einem bestimmten Kriterium.
 *
 * @param {Array<Object>} todos - Die zu sortierende Liste von ToDo-Objekten.
 * @param {('priority'|'createdAt')} [criterion='priority'] - Das Sortierkriterium.
 * 'priority': Sortiert nach Priorität (High > Normal > Low), mit Erstellungsdatum als Sekundärsortierung.
 * 'createdAt': Sortiert nach Erstellungsdatum (Neueste zuerst).
 * @returns {Array<Object>} Die neu sortierte Liste.
 */
export const sortTodos = (todos, criterion = 'priority') => {
  // Das ist unser "Schlüssel": Hohe Prio = 3, Niedrige Prio = 1.
  const priorityValue = { High: 3, Normal: 2, Low: 1 };
  
  // Kopie der Liste erstellen
  const sortedList = [...todos];

  // --- Sortierung nach Priorität (Der neue Standard) ---
  if (criterion === 'priority') {
      return sortedList.sort((a, b) => {
          const valA = priorityValue[a.priority] || 2;
          const valB = priorityValue[b.priority] || 2;
          
          // 1. Primärsortierung: Absteigend nach Priorität (High zuerst)
          if (valB !== valA) {
              return valB - valA; 
          }
          
          // 2. Sekundärsortierung: Wenn Priorität gleich ist, sortiere nach Erstellungsdatum (Neueste zuerst)
          // `createdAt` (oder `updatedAt`) ist in der Regel ein String oder ein Date-Objekt. 
          // Es wird angenommen, dass es sich um ISO 8601-Strings handelt, die alphabetisch verglichen werden können.
          if (a.createdAt > b.createdAt) return -1; // a ist neuer
          if (a.createdAt < b.createdAt) return 1;  // b ist neuer
          
          return 0; // Kein Unterschied in Priorität oder Zeitstempel
      });
  }
  
  // --- Sortierung nach Erstellungsdatum (Fallback/Alternative, falls implementiert) ---
  if (criterion === 'createdAt') {
      // Neueste zuerst (absteigend)
      return sortedList.sort((a, b) => {
          if (a.createdAt > b.createdAt) return -1;
          if (a.createdAt < b.createdAt) return 1;
          return 0;
      });
  }

  // Fallback: Unsortiert zurückgeben
  return sortedList;
};